import { useHeaderNavigateStyles } from "./header-navigate.styles";
import HeaderNavigateButtonMenuSvg from "../../static/header-navigate-button-menu.svg?react";
import { useContextPageRoot } from "../../context/root-context";
import { Icon } from "@/base/components/index";

export const HeaderNavigateButtonMenu = () => {
  const { styles } = useHeaderNavigateStyles();
  const { fetchOpenHeaderMenu } = useContextPageRoot();

  return (
    <Icon
      size={24}
      className={styles.buttonMenu}
      component={HeaderNavigateButtonMenuSvg}
      onClick={() => fetchOpenHeaderMenu()}
    />
  );
};
